export const QCTVWorkflow = {
  "id": 95,
  "wfName": "TV QC Report",
  "wfDescription": "QC Report for Television",
  "wide": true,
  "wfType": "QC",
  "wfData": {
    "header": {
      "width": 12,
      "rows": [
       [
          {
            "id": "program_title",
            "label": "Title",
            "width": 8
          },
          {
            "id": "elem_desc_wmls",
            "label": "WMLS #",
            "width": 2
          }, {
            "id": "house_number",
            "label": "House #",
            "width": 2
          }
        ], [
          {
            "id": "file_name",
            "label": "File",
            "width": 8
          },
          {
            "id": "foreign_episode_number",
            "label": "Foreign Eps",
            "width": 2
          }, {
            "id": "domestic_episode_number",
            "label": "Domestic Eps",
            "width": 2
          }
        ]
      ],
      "right": {
        "id": "status",
        "label": "Status",
        "width": 3
      },
    },
    "validations": {
      "at_least_one_required": [
        ["house_number"],
        ["elem_desc_wmls"],
        ["program_title", "program_version", "foreign_episode_number"],
        ["program_title", "program_version", "domestic_episode_number"]
      ]
    },
    "visible": [
    {
      "width": 9,
      "navigation_name": "Main",
      "rows": [
        [
          {
            "id": "disney_abc_wo_number",
            "type": "text",
            "label": "Disney-ABC WO#",
            "width": 2,
            "options": {
            }
          },
          {
            "id": "po_number",
            "type": "text",
            "label": "PO#",
            "width": 2,
            "options": {
            }
          },
          {
            "id": "vendor_wo_number",
            "type": "text",
            "label": "Vendor WO#",
            "width": 2,
            "options": {
            }
          },
          {
            "id": "house_number",
            "type": "text",
            "label": "House Number",
            "width": 2,
            "options": { }
          }, {
            "id": "revision",
            "type": "number",
            "label": "Revision",
            "width": 2,
            "options": { }
          },
          {
            "id": "status",
            "type": "jumbo_select",
            "label": "",
            "width": 2,
            "options": {
              "placeholder": "Status",
              "data": [
                {"displayed": "Fail", "stored": "Fail"},
                {"displayed": "In Progress", "stored": "In Progress"},
                {"displayed": "On Hold", "stored": "On Hold"},
                {"displayed": "Pass", "stored": "Pass"}
              ]
            }
          }
        ],
        [
          {
            "id": "program_title",
            "type": "nrg",
            "label": "Program Title",
            "width": 6,
            "options": {
              "placeholder": "Enter Program Title",
              "path": "Andouillette|DATG Programs|Features and Specials|"
            }
          },
          {
            "id": "program_version",
            "type": "autocomplete_select",
            "label": "Version",
            "width": 3,
            "options": {
              "data": [
                {"displayed": "3-D (3D)", "stored": "3-D (3D)"},
                {"displayed": "3-D Left Eye Version (3DL)", "stored": "3-D Left Eye Version (3DL)"},
                {"displayed": "3-D Right Eye Version (3DR)", "stored": "3-D Right Eye Version (3DR)"},
                {"displayed": "3-D Side-by-Side Version (3DSBS)", "stored": "3-D Side-by-side Version (3DSBS)"},
                {"displayed": "3-D Top-and-Bottom Version (3DTAB)", "stored": "3-D Top-and-Bottom Version (3DTAB)"},
                {"displayed": "AMXT (AMXT)", "stored": "AMXT (AMXT)"},
                {"displayed": "Censored (CNSR)", "stored": "Censored (CNSR)"},
                {"displayed": "Evergreen (EVRG)", "stored": "Evergreen (EVRG)"},
                {"displayed": "Home Entertainment (HE)", "stored": "Home Entertainment (HE)"},
                {"displayed": "Original Version (OV)", "stored": "Original Version (OV)"},
                {"displayed": "Shortened Version (SHRT)", "stored": "Shortened Version (SHRT)"},
                {"displayed": "Uncensored (UNCNSR)", "stored": "Uncensored (UNCNSR)"},
                {"displayed": "Unrated (UNR)", "stored": "Unrated (UNR)"}
              ]
            }
          },
          {
            "id": "master_origination",
            "type": "autocomplete_select",
            "label": "Master Origination",
            "width": 3,
            "options": {
              "data": [
                {"displayed": "Film", "stored": "film"},
                {"displayed": "Video", "stored": "video"}
              ]
            }
          }
        ],
        [
          {
            "id": "file_name",
            "type": "text",
            "label": "File Name",
            "width": 6,
            "options": { }
          },
          {
            "id": "record_date",
            "type": "date",
            "label": "Rec. Date",
            "width": 3,
            "options": {
              "format": "DD MMM YYYY"
            }
          },
          {
            "id": "qc_number",
            "type": "text",
            "label": "QC#",
            "width": 3,
            "options": { }
          }
        ],
        [
          {
            "id": "foreign_episode_number",
            "type": "text",
            "label": "Foreign Eps#",
            "width": 3,
            "options": { }
          },
          {
            "id": "domestic_episode_number",
            "type": "text",
            "label": "Domestic Eps#",
            "width": 3,
            "options": { }
          },
          {
            "id": "production_number",
            "type": "text",
            "label": "Production#",
            "width": 3,
            "options": { }
          },
          {
            "id": "qc_type",
            "type": "autocomplete_select",
            "label": "QC Type",
            "width": 3,
            "options": {
              "data": [
                {"displayed": "100% File", "stored": "100% File"},
                {"displayed": "5pt Spot Check", "stored": "5pt Spot Check"},
                {"displayed": "File Integrity", "stored": "File Integrity"},
                {"displayed": "Master", "stored": "Master"},
                {"displayed": "Grand Master HD 2 CH", "stored": "Grand Master HD 2 CH"},
                {"displayed": "File Integrity with Verification", "stored": "File Integrity with Verification"},
                {"displayed": "Fix", "stored": "Fix"},
                {"displayed": "QC File 4 CH", "stored": "QC File 4 CH"},
                {"displayed": "QC File 2 CH", "stored": "QC File 2 CH"},
                {"displayed": "Sync Verification", "stored": "Sync Verification"},
                {"displayed": "Dirt List", "stored": "Dirt List"},
                {"displayed": "Preliminary VAM", "stored": "Preliminary VAM"},
                {"displayed": "Grand Master HD 4 CH", "stored": "Grand Master HD 4 CH"},
                {"displayed": "Grand Master HD 8 CH", "stored": "Grand Master HD 8 CH"}
              ]
            }
          }
        ],
        [
          {
            "id": "episode_title",
            "type": "text",
            "label": "Episode Title",
            "width": 6,
            "options": {
            }
          },
          {
            "id": "master_arrival_date",
            "type": "date",
            "label": "Master Arrival Date",
            "width": 3,
            "options": {
              "format": "DD MMM YYYY"
            }
          },
          {
            "id": "qc_date",
            "type": "date",
            "label": "QC Date",
            "width": 3,
            "options": {
              "format": "DD MMM YYYY"
            }
          }
        ]
      ]
    },
    {
      "width": 6,
      "subsections": [
        {
          "section_name": "Element Description",
          "rows": [
            [
              {
                "id": "vendor_elem_barcode",
                "type": "text",
                "label": "Vendor Barcode",
                "width": 3,
                "options": {}
              },
              {
                "id": "elem_desc_wmls",
                "type": "text",
                "label": "WMLS #",
                "width": 3,
                "options": { }
              }
            ],
            [
              {
                "id": "element_type",
                "type": "autocomplete_select",
                "label": "Element Type",
                "width": 3,
                "options": {
                  "data": [
                    {"displayed": "Client-Specific Deliverable", "stored": "Client-Specific Deliverable"},
                    {"displayed": "Digital Master", "stored": "Digital Master"},
                    {"displayed": "Distribution Master", "stored": "Distribution Master"},
                    {"displayed": "Domestic Source Master", "stored": "Domestic Source Master"},
                    {"displayed": "Dual Language Master", "stored": "Dual Language Master"},
                    {"displayed": "Element Reel", "stored": "Element Reel" },
                    {"displayed": "Interim Master", "stored": "Interim Master"},
                    {"displayed": "Language Master", "stored": "Language Master"},
                    {"displayed": "Original Version Production Master", "stored": "Original Version Production Master" },
                    {"displayed": "Production Master", "stored": "Production Master"},
                    {"displayed": "Tri-Language Master", "stored": "Tri-Language Master"},
                    {"displayed": "Unfinished Master", "stored": "Unfinished Master"}

                  ]
                }
              },
              {
                "id": "format",
                "type": "autocomplete_select",
                "label": "Format",
                "width": 3,
                "options": {
                  "data": [
                    {"displayed": "ProRes HQ", "stored": "ProRes HQ"},
                    {"displayed": "ProRes 4:4:4 HQ", "stored": "ProRes 4:4:4 HQ"},
                    {"displayed": "ProRes LT", "stored": "ProRes LT"},
                    {"displayed": "ProRes Non-HQ", "stored": "ProRes Non-HQ"},
                    {"displayed": "ProRes XQ", "stored": "ProRes XQ"},
                    {"displayed": "IMF", "stored": "IMF"},
                    {"displayed": "DCP", "stored": "DCP"},
                    {"displayed": "UHD-Rec709", "stored": "UHD-Rec709"},
                    {"displayed": "Mpeg2", "stored": "Mpeg2"},
                    {"displayed": "Mpeg4", "stored": "Mpeg4"},
                    {"displayed": "XDCam HD 4:2:2", "stored": "XDCam HD 4:2:2"},
                    {"displayed": "IMX30i 29.97 SD", "stored": "IMX30i 29.97 SD"},
                    {"displayed": "IMX50 29.97 SD", "stored": "IMX50 29.97 SD"},
                    {"displayed": "HDCam", "stored": "HDCam"},
                    {"displayed": "HDCamSR 4:2:2", "stored": "HDCamSR 4:2:2"},
                    {"displayed": "HDCamSR 4:4:4", "stored": "HDCamSR 4:4:4"},
                    {"displayed": "DPX", "stored": "DPX"},
                    {"displayed": "J2K", "stored": "J2K"},
                    {"displayed": "MJPEG", "stored": "MJPEG"},
                    {"displayed": "DNX", "stored": "DNX"},
                    {"displayed": "DVCPro 100", "stored": "DVCPro 100"},
                    {"displayed": "DigiBeta", "stored": "DigiBeta"},
                    {"displayed": "D5", "stored": "D5"}
                  ]
                }
              }
            ],
            [
              {
                "id": "standard",
                "type": "timecode_standard",
                "width": 6,
                "options": { }
              }
            ],
            [
              {
                "id": "wrapper",
                "type": "autocomplete_select",
                "label": "Wrapper",
                "width": 2,
                "options": {
                  "data": [
                    {"stored": "Quicktime", "displayed": "Quicktime"},
                    {"stored": "MXF", "displayed": "MXF"},
                    {"stored": "Transport Stream", "displayed": "Transport Stream"},
                    {"stored": "Program Stream", "displayed": "Program Stream"},
                    {"stored": "IMF", "displayed": "IMF"},
                    {"stored": "MP4", "displayed": "MP4"}
                  ]
                },
              },
              {
                "id": "first_active_line",
                "type": "text",
                "label": "First Active Line",
                "width": 2,
                "options": { }
              },
              {
                "id": "last_active_line",
                "type": "text",
                "label": "Last Active Line",
                "width": 2,
                "options": { }
              }
            ],
            [

              {
                "id": "file_size",
                "type": "text",
                "label": "File Size",
                "width": 2,
                "options": { }
              },
              {
                "id": "file_units",
                "type": "autocomplete_select",
                "label": "File Size Units",
                "width": 2,
                "options": {
                  "data": [
                    {"stored": "MB", "displayed": "MB"},
                    {"stored": "GB", "displayed": "GB"},
                    {"stored": "TB", "displayed": "TB"}
                  ],
                  "default": {"displayed": "GB", "stored": "GB"}
                }
              },
              {
                "id": "file_extension",
                "type": "autocomplete_select",
                "label": "File Extension",
                "width": 2,
                "options": {
                  "data": [
                    {"displayed": ".mov", "stored": ".mov"},
                    {"displayed": ".mxf", "stored": ".mxf"},
                    {"displayed": ".mpg", "stored": ".mpg"},
                    {"displayed": ".mp4", "stored": ".mp4"},
                    {"displayed": ".ts", "stored": ".ts"},
                    {"displayed": ".imf", "stored": ".imf"},
                    {"displayed": ".aiff", "stored": ".aiff"}
                  ]
                }
              },
              {
                "id": "conversion",
                "type": "autocomplete_select",
                "label": "Conversion",
                "width": 2,
                "options": {
                  "data": [
                    {"displayed": "No", "stored": "No"},
                    {"displayed": "Frame-Rate", "stored": "Frame-Rate"},
                    {"displayed": "De-Interlaced", "stored": "De-Interlaced"},
                    {"displayed": "Alchemist Platinum", "stored": "Alchemist Platinum"},
                    {"displayed": "Teranax", "stored": "Teranax"},
                    {"displayed": "Standards", "stored": "Standards"},
                    {"displayed": "UFC", "stored": "UFC"}
                  ]
                }
              }
            ]
          ]
        },
        {
          "section_name": "Source Element",
          "rows": [
            [
              {
                "id": "source_format",
                "type": "autocomplete_select",
                "label": "Format",
                "width": 3,
                "options": {
                  "data": [
                    {"displayed": "HD ProRes 4:2:2 HQ", "stored": "HD ProRes 4:2:2 HQ"},
                    {"displayed": "Mpeg2", "stored": "Mpeg2"},
                    {"displayed": "Mpeg4", "stored": "Mpeg4"},
                    {"displayed": "XDCAM HD 4:2:2", "stored": "XDCAM HD 4:2:2"},
                    {"displayed": "IMX", "stored": "IMX"},
                    {"displayed": "SD ProRes", "stored": "SD ProRes"},
                    {"displayed": "HD ProRes 4:4:4 HQ", "stored": "HD ProRes 4:4:4 HQ"},
                    {"displayed": "HDCAM SR", "stored": "HDCAM SR"},
                    {"displayed": "D5", "stored": "D5"},
                    {"displayed": "DPX", "stored": "DPX"},
                    {"displayed": "J2K", "stored": "J2K"},
                    {"displayed": "MJPEG", "stored": "MJPEG"},
                    {"displayed": "DNX", "stored": "DNX"},
                    {"displayed": "HD ProRes Non-HQ", "stored": "HD ProRes Non-HQ"},
                    {"displayed": "DVCPro 100", "stored": "DVCPro 100"}
                  ]
                }
              },
              {
                "id": "source_standard",
                "type": "autocomplete_select",
                "label": "Standard",
                "width": 3,
                "options": {
                  "data": [
                    {"displayed": "1080p 23.98", "stored": "1080p 23.98", "standard": {"fps": 24, "format": "1080p 23.98"}, "linked_categories": ["NDF"]},
                    {"displayed": "1080i 29.97", "stored": "1080i 29.97", "standard": {"fps": 30, "format": "1080i 29.97"}, "linked_categories": ["DF", "NDF"]},
                    {"displayed": "1080i 50", "stored": "1080i 50", "standard": {"fps": 50, "format": "1080i 50"}, "linked_categories": ["NDF"]},
                    {"displayed": "1080i 59.94", "stored": "1080i 59.94", "standard": {"fps": 60, "format": "1080i 59.94"}, "linked_categories": ["DF", "NDF"]},
                    {"displayed": "1080p 25", "stored": "1080p 25", "standard": {"fps": 25, "format": "1080p 25"}, "linked_categories": ["NDF"]},
                    {"displayed": "720p 50", "stored": "720p 50", "standard": {"fps": 50, "format": "720p 50"}, "linked_categories": ["NDF"]},
                    {"displayed": "720p 59.94", "stored": "720p 59.94", "standard": {"fps": 60, "format": "720p 59.94"}, "linked_categories": ["DF", "NDF"]},
                    {"displayed": "IMX 30 (SD 29.97)", "stored": "IMX 30 (SD 29.97)", "standard": {"fps": 30, "format": "IMX 30 (SD 29.97)"}, "linked_categories": ["DF", "NDF"]},
                    {"displayed": "NTSC", "stored": "NTSC", "standard": {"fps": 30, "format": "NTSC"}, "linked_categories": ["DF", "NDF"]},
                    {"displayed": "PAL", "stored": "PAL", "standard": {"fps": 25, "format": "PAL"}, "linked_categories": ["NDF"]}
                  ]
                }
              }
            ],
            [
              {
                "id": "part",
                "type": "text",
                "label": "Part",
                "width": 1,
                "options": { }
              },
              {
                "id": "wmls",
                "type": "text",
                "label": "WMLS #",
                "width": 3,
                "options": { }
              },
              {
                "id": "vendor_barcode",
                "type": "text",
                "label": "Vendor Barcode",
                "width": 3,
                "options": { }
              }
            ]
          ]
        },
        {
          "section_name": "Vendor Information",
          "width": 12,
          "rows": [
            [
              {
                "id": "qc_vendor",
                "type": "autocomplete_select",
                "label": "QC Vendor",
                "width": 6,
                "options": {
                  "data": [
                    {"displayed": "Arsenal", "stored": "Arsenal"},
                    {"displayed": "Brown Bag", "stored": "Brown Bag"},
                    {"displayed": "Chainsaw", "stored": "Chainsaw"},
                    {"displayed": "DATG Media Services", "stored": "DATG Media Services"},
                    {"displayed": "Deluxe", "stored": "Deluxe"},
                    {"displayed": "Digital Film Tree", "stored": "Digital Film Tree"},
                    {"displayed": "Disney TVA", "stored": "Disney TVA"},
                    {"displayed": "Encore", "stored": "Encore"},
                    {"displayed": "Fotokem", "stored": "Fotokem"},
                    {"displayed": "Headquarters", "stored": "Headquarters"},
                    {"displayed": "It's a Laugh", "stored": "It's a Laugh"},
                    {"displayed": "Keep Me Posted", "stored": "Keep Me Posted"},
                    {"displayed": "Level 3 Post", "stored": "Level 3 Post"},
                    {"displayed": "Modern Videofilm", "stored": "Modern Videofilm"},
                    {"displayed": "Pixelogic", "stored": "Pixelogic"},
                    {"displayed": "Point 360", "stored": "Point 360"},
                    {"displayed": "Post 6", "stored": "Post 6"},
                    {"displayed": "Roundabout", "stored": "Roundabout"},
                    {"displayed": "SonicPool - Hollywood", "stored": "SonicPool - Hollywood"},
                    {"displayed": "Technicolor - Glendale", "stored": "Technicolor - Glendale"},
                    {"displayed": "Technicolor - Hollywood", "stored": "Technicolor - Hollywood"},
                    {"displayed": "The Loft Post", "stored": "The Loft Post"},
                    {"displayed": "Visual Data Media Services, Inc", "stored": "Visual Data Media Services, Inc"}
                  ]
                }
              }
            ],
            [
              {
                "id": "qc_vtr",
                "type": "text",
                "label": "QC VTR",
                "width": 3,
                "options": { }
              },
              {
                "id": "operators",
                "type": "list",
                "label": "Operators",
                "width": 3,
                "options": { }
              }
            ],
            [
              {
                "id": "label",
                "type": "text",
                "label": "Label",
                "width": 6,
                "options": { }
              }
            ],
            [
              {
                "id": "record_vendor",
                "type": "text",
                "label": "Rec. Vendor",
                "width": 3,
                "options": { }
              },
              {
                "id": "revised_by",
                "type": "text",
                "label": "Revised By",
                "width": 3,
                "options": { }
              }
            ],
            [
              {
                "id": "record_vtr",
                "type": "text",
                "label": "Rec. VTR",
                "width": 6,
                "options": { }
              }
            ],
          ]
        }
      ]
    },
    {
      "width": 6,
      "subsections": [
        {
          "section_name": "Video",
          "rows": [
            [
              {
                "id": "resolution",
                "type": "autocomplete_select",
                "label": "Resolution",
                "width": 2,
                "options": {
                  "data": [
                    {"displayed": "1920x1080", "stored": "1920x1080"},
                    {"displayed": "1280x720", "stored": "1280x720"},
                    {"displayed": "1024x576", "stored": "1024x576"},
                    {"displayed": "720x608", "stored": "720x608"},
                    {"displayed": "720x608i", "stored": "720x608i"},
                    {"displayed": "720x576", "stored": "720x576"},
                    {"displayed": "720x512", "stored": "720x512"},
                    {"displayed": "720x486", "stored": "720x486"},
                    {"displayed": "720x480", "stored": "720x480"}
                  ]
                }
              },
              {
                "id": "picture_structure",
                "type": "autocomplete_select",
                "label": "Picture Structure", // or Field Dominance
                "width": 2,
                "options": {
                  "data": [
                    {"displayed": "Progressive", "stored": "Progressive"},
                    {"displayed": "Interlaced", "stored": "Interlaced"},
                  ]
                }
              },
              {
                "id": "pixel_aspect_ratio",
                "type": "autocomplete_select",
                "label": "Pixel Aspect Ratio",
                "width": 2,
                "options": {
                  "data": [
                    {"displayed": "Square", "stored": "Square"},
                    {"displayed": "16x9 1.33 PB", "stored": "16x9 1.33 PB"},
                    {"displayed": "16x9 1.78 FF", "stored": "16x9 1.78 FF"},
                    {"displayed": "16x9 1.85 LB", "stored": "16x9 1.85 LB"},
                    {"displayed": "16x9 2.35 LB", "stored": "16x9 2.35 LB"},
                    {"displayed": "16x9 2.40 LB", "stored": "16x9 2.40 LB"},
                    {"displayed": "4x3 1.33 FF", "stored": "4x3 1.33 FF"},
                    {"displayed": "4x3 1.78 LB", "stored": "4x3 1.78 LB"},
                    {"displayed": "4x3 1.85 LB", "stored": "4x3 1.85 LB"},
                    {"displayed": "4x3 2.35 LB", "stored": "4x3 2.35 LB"},
                    {"displayed": "4x3 2.40 LB", "stored": "4x3 2.40 LB"},
                    {"displayed": "4x3 1.78 FHA", "stored": "4x3 1.78 FHA"},
                    {"displayed": "4x3 1.85 FHA", "stored": "4x3 1.85 FHA"},
                    {"displayed": "4x3 2.35 FHA", "stored": "4x3 2.35 FHA"},
                    {"displayed": "4x3 2.40 FHA", "stored": "4x3 2.40 FHA"},
                    {"displayed": "Other", "stored": "Other"}
                  ]
                }
              },
              {
                "id": "video_bit_depth",
                "type": "text",
                "label": "Bit Depth",
                "width": 2,
                "options": {
                  "suffix": "b/s",
                }
              }
            ],
            [
              {
                "id": "video_codec",
                "type": "autocomplete_select",
                "label": "Codec",
                "width": 2,
                "options": {
                  "data": [
                    {"displayed": "HD ProRes 4:2:2 HQ", "stored": "HD ProRes 4:2:2 HQ"},
                    {"displayed": "Mpeg2", "stored": "Mpeg2"},
                    {"displayed": "Mpeg4", "stored": "Mpeg4"},
                    {"displayed": "XDCAM HD 4:2:2", "stored": "XDCAM HD 4:2:2"},
                    {"displayed": "IMX", "stored": "IMX"},
                    {"displayed": "SD ProRes", "stored": "SD ProRes"},
                    {"displayed": "HD ProRes 4:4:4 HQ", "stored": "HD ProRes 4:4:4 HQ"},
                    {"displayed": "HDCAM SR", "stored": "HDCAM SR"},
                    {"displayed": "D5", "stored": "D5"},
                    {"displayed": "DPX", "stored": "DPX"},
                    {"displayed": "J2K", "stored": "J2K"},
                    {"displayed": "MJPEG", "stored": "MJPEG"},
                    {"displayed": "DNX", "stored": "DNX"},
                    {"displayed": "HD ProRes Non-HQ", "stored": "HD ProRes Non-HQ"},
                    {"displayed": "DVCPro 100", "stored": "DVCPro 100"}
                  ]
                }
              },
              {
                "id": "video_bit_rate",
                "type": "text",
                "label": "Video Bit Rate",
                "width": 2,
                "options": { }
              },
              {
                "id": "video_bit_rate_units",
                "type": "autocomplete_select",
                "label": "Video Bit Units",
                "width": 2,
                "options": {
                  "suffix": "Mb/s",
                  "data": [
                    {"displayed": "Kbps", "stored": "Kbps"},
                    {"displayed": "Mbps", "stored": "Mbps"},
                    {"displayed": "Gbps", "stored": "Gbps"}
                  ],
                  "default": {"displayed": "Mbps", "stored": "Mbps"}
                }
              },
              {
                "id": "video_encode_method",
                "type": "autocomplete_select",
                "label": "Encode Method",
                "width": 2,
                "options": {
                  "data": [
                    {"displayed": "CBR", "stored": "CBR"},
                    {"displayed": "VBR", "stored": "VBR"},
                    {"displayed": "Uncompressed", "stored": "Uncompressed"}
                  ]
                }
              }
            ],
          ]
        },
        {
          "section_name": "Audio",
          "rows": [
            [
              {
                "id": "audio_format",
                "type": "autocomplete_select",
                "label": "Format",
                "width": 2,
                "options": {
                  "data": [
                    {"displayed": "16-bit integer", "stored": "16-bit integer"},
                    {"displayed": "24-bit integer", "stored": "24-bit integer"}
                  ]
                }
              },
              {
                "id": "audio_sample_rate",
                "type": "text",
                "label": "Audio Sample Bit Rate",
                "width": 2,
                "options": { }
              },
              {
                "id": "audio_sample_rate_units",
                "type": "autocomplete_select",
                "label": "Audio Sample Units",
                "width": 2,
                "options": {
                  "data": [
                    {"displayed": "kHz", "stored": "kHz"},
                    {"displayed": "Hz", "stored": "Hz"}
                  ],
                  "default": {"displayed": "kHz", "stored": "kHz"}
                 }
              },
              {
                "id": "audio_bit_depth",
                "type": "text",
                "label": "Bit Depth",
                "width": 2,
                "options": {
                  "suffix": "b/s",
                }
              }
            ],
            [
              {
                "id": "audio_codec",
                "type": "autocomplete_select",
                "label": "Codec",
                "width": 2,
                "options": {
                  "data": [
                    {"displayed": "PCM", "stored": "PCM"},
                    {"displayed": "AES", "stored": "AES"},
                    {"displayed": "Little Endian", "stored": "Little Endian"},
                    {"displayed": "WAV", "stored": "WAV"},
                    {"displayed": "AC3", "stored": "AC3"}
                  ]
                }
              },
              {
                "id": "audio_bit_rate",
                "type": "text",
                "label": "Audio Bit Rate",
                "width": 2,
                "options": { }
              },
              {
                "id": "audio_bit_rate_units",
                "type": "autocomplete_select",
                "label": "Audio Bit Units",
                "width": 2,
                "options": {
                  "suffix": "Mb/s",
                  "data": [
                    {"displayed": "Kbps", "stored": "Kbps"},
                    {"displayed": "Mbps", "stored": "Mbps"},
                    {"displayed": "Gbps", "stored": "Gbps"}
                  ],
                  "default": {"displayed": "Mbps", "stored": "Mbps"}
                }
              },
              {
                "id": "audio_encode_method",
                "type": "autocomplete_select",
                "label": "Encode Method",
                "width": 2,
                "options": {
                  "data": [
                    {"displayed": "CBR", "stored": "CBR"},
                    {"displayed": "VBR", "stored": "VBR"},
                    {"displayed": "Uncompressed", "stored": "Uncompressed"}
                  ]
                }
              }
            ]
          ]
        },
        {
          "section_name": "Captioning/Subtitles",
          "width": 6,
          "rows": [[
            {
              "id": "captions",
              "label": "Captions",
              "type": "autocomplete_select",
              "width": 3,
              "options": {
                "placeholder": "None",
                "data": [
                  {"displayed": "608 Embedded", "stored": "608 Embedded"},
                  {"displayed": "708 Embedded", "stored": "708 Embedded"},
                  {"displayed": "SMPTE-TT Sidecar", "stored": "SMPTE-TT Sidecar"},
                  {"displayed": ".CAP Sidecar", "stored": ".CAP Sidecar"},
                  {"displayed": ".SCC Sidecar", "stored": ".SCC Sidecar"}
                ]
              }
            },
            {
              "id": "subtitles",
              "label": "Subtitles",
              "type": "autocomplete_select",
              "width": 3,
              "options": {
                "data": [
                  {"displayed": "Yes", "stored": "Yes"},
                  {"displayed": "No", "stored": "No"},
                ]
              }
            },
          ],
          [
            {
              "id": "captions_language",
              "type": "nrg",
              "label": "Language",
              "width": 6,
              "options": {
                "path": "Andouillette|Language Details|"
              }
            },
          ],
          [
            {
              "id": "captions_sync",
              "type": "text",
              "label": "Sync",
              "width": 2,
              "options": { }
            },
            {
              "id": "captions_color",
              "type": "text",
              "label": "Color",
              "width": 2,
              "options": { }
            },
            {
              "id": "captions_sync_quality",
              "type": "text",
              "label": "Quality",
              "width": 2,
              "options": { }
            }
          ]]
        }
      ]
    },
    {
      "section_name": "Audio Configuration",
      "width": 12,
      "rows": [[
        {
          "id": "audio_language",
          "type": "nrg",
          "label": "Language",
          "width": 3,
          "options": {
            "path": "Andouillette|Language Details|"
          }
        },
        {
          "id": "audio_channels_configuration",
          "label": "Preset (optional)",
          "type": "autocomplete_select",
          "width": 3,
          "links": [{"id": "audio_channels"}],
          "options": {
            "data": [
              {
                "displayed": "2.0 Stereo",
                "stored": "2.0 Stereo",
                "linked": [
                  {
                    "channel": "1",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "2.0 Left",
                      "displayed": "2.0 Left"
                    }
                  }, {
                    "channel": "2",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "2.0 Right",
                      "displayed": "2.0 Right"
                    }
                  }, {
                    "channel": "3",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "Stereo M&E",
                      "displayed": "Stereo M&E"
                    }
                  }, {
                    "channel": "4",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "Stereo M&E",
                      "displayed": "Stereo M&E"
                    }
                  }
                ]
              },
              {
                "displayed": "5.1 Surround",
                "stored": "5.1 Surround",
                "linked": [
                  {
                  "channel": "1",
                  "language": {
                    "stored": "English",
                    "displayed": "English"
                  },
                  "configuration": {
                    "stored": "5.1 Left",
                    "displayed": "5.1 Left"
                  }
                  },
                  {
                    "channel": "2",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "5.1 Right",
                      "displayed": "5.1 Right"
                    }
                  },
                  {
                    "channel": "3",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "5.1 Center",
                      "displayed": "5.1 Center"
                    }
                  },
                  {
                    "channel": "4",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "5.1 Subwoofer",
                      "displayed": "5.1 Subwoofer"
                    }
                  },
                  {
                    "channel": "5",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "5.1 Left Surround",
                      "displayed": "5.1 Left Surround"
                    }
                  },
                  {
                    "channel": "6",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "5.1 Right Surround",
                      "displayed": "5.1 Right Surround"
                    }
                  }, {
                    "channel": "7",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "Stereo Comp L",
                      "displayed": "Stereo Comp L"
                    }
                  }, {
                    "channel": "8",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "Stereo Comp R",
                      "displayed": "Stereo Comp R"
                    }
                  }
                ]
              },
              {
                "displayed": "7.1 Surround",
                "stored": "7.1 Surround",
                "linked": [
                  {
                  "channel": "1",
                  "language": {
                    "stored": "English",
                    "displayed": "English"
                  },
                  "configuration": {
                    "stored": "7.1 Left",
                    "displayed": "7.1 Left"
                  }
                  },
                  {
                    "channel": "2",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "7.1 Right",
                      "displayed": "7.1 Right"
                    }
                  },
                  {
                    "channel": "3",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "7.1 Center",
                      "displayed": "7.1 Center"
                    }
                  },
                  {
                    "channel": "4",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "7.1 Subwoofer",
                      "displayed": "7.1 Subwoofer"
                    }
                  },
                  {
                    "channel": "5",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "7.1 Left Surround",
                      "displayed": "7.1 Left Surround"
                    }
                  },
                  {
                    "channel": "6",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "7.1 Right Surround",
                      "displayed": "7.1 Right Surround"
                    }
                  },
                  {
                    "channel": "7",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "7.1 Left Surround Rear",
                      "displayed": "7.1 Left Surround Rear"
                    }
                  },
                  {
                    "channel": "8",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "7.1 Right Surround Rear",
                      "displayed": "7.1 Right Surround Rear"
                    }
                  }
                ]
              },
              {
                "displayed": "2.0 Stereo-8 CH",
                "stored": "2.0 Stereo-8 CH",
                "linked": [
                  {
                    "channel": "1",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "Stereo Comp",
                      "displayed": "Stereo Comp"
                    }
                  }, {
                    "channel": "2",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "Stereo Comp",
                      "displayed": "Stereo Comp"
                    }
                  }, {
                    "channel": "3",
                    "configuration": {
                      "stored": "MOS",
                      "displayed": "MOS"
                    }
                  }, {
                    "channel": "4",
                    "configuration": {
                      "stored": "MOS",
                      "displayed": "MOS"
                    }
                  }, {
                    "channel": "5",
                    "configuration": {
                      "stored": "MOS",
                      "displayed": "MOS"
                    }
                  }, {
                    "channel": "6",
                    "configuration": {
                      "stored": "MOS",
                      "displayed": "MOS"
                    }
                  }, {
                    "channel": "7",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "Stereo Comp",
                      "displayed": "Stereo Comp"
                    }
                  }, {
                    "channel": "8",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "Stereo Comp",
                      "displayed": "Stereo Comp"
                    }
                  },
                ]
              },
              {
                "displayed": "DATG 2.0 Stereo",
                "stored": "DATG 2.0 Stereo",
                "linked": [
                  {
                    "channel": "1",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "2.0 Left Total",
                      "displayed": "2.0 Left Total"
                    }
                  },
                  {
                    "channel": "2",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "2.0 Right Total",
                      "displayed": "2.0 Right Total"
                    }
                  },
                  {
                    "channel": "3",
                    "configuration": {
                      "stored": "MOS",
                      "displayed": "MOS"
                    }
                  },
                  {
                    "channel": "4",
                    "configuration": {
                      "stored": "MOS",
                      "displayed": "MOS"
                    }
                  },
                  {
                    "channel": "5",
                    "configuration": {
                      "stored": "MOS",
                      "displayed": "MOS"
                    }
                  },
                  {
                    "channel": "6",
                    "configuration": {
                      "stored": "MOS",
                      "displayed": "MOS"
                    }
                  }, {
                    "channel": "7",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "2.0 Left Total",
                      "displayed": "2.0 Left Total"
                    }
                  }, {
                    "channel": "8",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "2.0 Right Total",
                      "displayed": "2.0 Right Total"
                    }
                  },
                  {
                    "channel": "9",
                    "configuration": {
                      "stored": "MOS",
                      "displayed": "MOS"
                    }
                  },
                  {
                    "channel": "10",
                    "configuration": {
                      "stored": "MOS",
                      "displayed": "MOS"
                    }
                  },
                  {
                    "channel": "11",
                    "configuration": {
                      "stored": "MOS",
                      "displayed": "MOS"
                    }
                  },
                  {
                    "channel": "12",
                    "configuration": {
                      "stored": "MOS",
                      "displayed": "MOS"
                    }
                  },
                  {
                    "channel": "13",
                    "configuration": {
                      "stored": "MOS",
                      "displayed": "MOS"
                    }
                  },
                  {
                    "channel": "14",
                    "configuration": {
                      "stored": "MOS",
                      "displayed": "MOS"
                    }
                  }, {
                    "channel": "15",
                    "configuration": {
                      "stored": "2.0 M&E Left Total",
                      "displayed": "2.0 M&E Left Total"
                    }
                  }, {
                    "channel": "16",
                    "configuration": {
                      "stored": "2.0 M&E Right Total",
                      "displayed": "2.0 M&E Right Total"
                    }
                  }, {
                    "channel": "17",
                    "configuration": {
                      "stored": "1.0 Dialog",
                      "displayed": "1.0 Dialog"
                    }
                  }, {
                    "channel": "18",
                    "configuration": {
                      "stored": "1.0 EFX",
                      "displayed": "1.0 EFX"
                    }
                  }, {
                    "channel": "19",
                    "configuration": {
                      "stored": "2.0 Music Left",
                      "displayed": "2.0 Music Left"
                    }
                  }, {
                    "channel": "20",
                    "configuration": {
                      "stored": "2.0 Music Right",
                      "displayed": "2.0 Music Right"
                    }
                  }, {
                    "channel": "21",
                    "configuration": {
                      "stored": "MOS",
                      "displayed": "MOS"
                    }
                  }, {
                    "channel": "22",
                    "configuration": {
                      "stored": "MOS",
                      "displayed": "MOS"
                    }
                  }, {
                    "channel": "23",
                    "configuration": {
                      "stored": "MOS",
                      "displayed": "MOS"
                    }
                  }, {
                    "channel": "24",
                    "configuration": {
                      "stored": "MOS",
                      "displayed": "MOS"
                    }
                  }
                ]
              },
              {
                "displayed": "DATG 5.1 Surround",
                "stored": "DATG 5.1 Surround",
                "linked": [
                  {
                    "channel": "1",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "5.1 Left",
                      "displayed": "5.1 Left"
                    }
                  },
                  {
                    "channel": "2",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "5.1 Right",
                      "displayed": "5.1 Right"
                    }
                  },
                  {
                    "channel": "3",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "5.1 Center",
                      "displayed": "5.1 Center"
                    }
                  },
                  {
                    "channel": "4",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "5.1 Subwoofer",
                      "displayed": "5.1 Subwoofer"
                    }
                  },
                  {
                    "channel": "5",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "5.1 Left Surround",
                      "displayed": "5.1 Left Surround"
                    }
                  },
                  {
                    "channel": "6",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "5.1 Right Surround",
                      "displayed": "5.1 Right Surround"
                    }
                  }, {
                    "channel": "7",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "2.0 Left Total",
                      "displayed": "2.0 Left Total"
                    }
                  }, {
                    "channel": "8",
                    "language": {
                      "stored": "English",
                      "displayed": "English"
                    },
                    "configuration": {
                      "stored": "2.0 Right Total",
                      "displayed": "2.0 Right Total"
                    }
                  },
                  {
                    "channel": "9",
                    "configuration": {
                      "stored": "5.1 M&E Left",
                      "displayed": "5.1 M&E Left"
                    }
                  },
                  {
                    "channel": "10",
                    "configuration": {
                      "stored": "5.1 M&E Right",
                      "displayed": "5.1 M&E Right"
                    }
                  },
                  {
                    "channel": "11",
                    "configuration": {
                      "stored": "5.1 M&E Center",
                      "displayed": "5.1 M&E Center"
                    }
                  },
                  {
                    "channel": "12",
                    "configuration": {
                      "stored": "5.1 M&E Subwoofer",
                      "displayed": "5.1 M&E Subwoofer"
                    }
                  },
                  {
                    "channel": "13",
                    "configuration": {
                      "stored": "5.1 M&E Left Surround",
                      "displayed": "5.1 M&E Left Surround"
                    }
                  },
                  {
                    "channel": "14",
                    "configuration": {
                      "stored": "5.1 M&E Right Surround",
                      "displayed": "5.1 M&E Right Surround"
                    }
                  }, {
                    "channel": "15",
                    "configuration": {
                      "stored": "2.0 M&E Left Total",
                      "displayed": "2.0 M&E Left Total"
                    }
                  }, {
                    "channel": "16",
                    "configuration": {
                      "stored": "2.0 M&E Right Total",
                      "displayed": "2.0 M&E Right Total"
                    }
                  }, {
                    "channel": "17",
                    "configuration": {
                      "stored": "1.0 Dialog",
                      "displayed": "1.0 Dialog"
                    }
                  }, {
                    "channel": "18",
                    "configuration": {
                      "stored": "1.0 EFX",
                      "displayed": "1.0 EFX"
                    }
                  }, {
                    "channel": "19",
                    "configuration": {
                      "stored": "2.0 Music Left",
                      "displayed": "2.0 Music Left"
                    }
                  }, {
                    "channel": "20",
                    "configuration": {
                      "stored": "2.0 Music Right",
                      "displayed": "2.0 Music Right"
                    }
                  }, {
                    "channel": "21",
                    "configuration": {
                      "stored": "MOS",
                      "displayed": "MOS"
                    }
                  }, {
                    "channel": "22",
                    "configuration": {
                      "stored": "MOS",
                      "displayed": "MOS"
                    }
                  }, {
                    "channel": "23",
                    "configuration": {
                      "stored": "MOS",
                      "displayed": "MOS"
                    }
                  }, {
                    "channel": "24",
                    "configuration": {
                      "stored": "MOS",
                      "displayed": "MOS"
                    }
                  }
                ]
              }
            ]
          }
        },
        {
          "id": "stereo_phase",
          "type": "autocomplete_select",
          "label": "Stereo Phase",
          "width": 3,
          "options": {
            "data": [
              {"displayed": "Pass", "stored": "Pass"},
              {"displayed": "Fail", "stored": "Fail"}
            ]
          }
        },
        {
          "id": "comp_mne_sync",
          "type": "autocomplete_select",
          "label": "Comp/M&E Sync",
          "width": 3,
          "options": {
            "data": [
              {"displayed": "Pass", "stored": "Pass"},
              {"displayed": "Fail", "stored": "Fail"},
              {"displayed": "MnE Not Present", "stored": "MnE Not Present"},
            ]
          }
        }
      ],
      [
        {
          "id": "audio_channels",
          "label": "Audio Channels",
          "type": "table",
          "width": 12,
          "options": {
            "min_value": 1,
            "draggable": true
          },
          "fields": [
            {
              "id": "channel",
              "label": "CH",
              "type": "auto_index",
              "options": { }
            }, {
              "id": "language",
              "label": "Language",
              "type": "autocomplete_select",
              "width": 3,
              "options": {
                "data": [
                  {"displayed": "Arabic Classical", "stored": "Arabic Classical"},
                  {"displayed": "Arabic Egyptian", "stored": "Arabic Egyptian"},
                  {"displayed": "Arabic Lebanese", "stored": "Arabic Lebanese"},
                  {"displayed": "Arabic Mixed", "stored": "Arabic Mixed"},
                  {"displayed": "Austrian", "stored": "Austrian"},
                  {"displayed": "Bulgarian", "stored": "Bulgarian"},
                  {"displayed": "Cantonese", "stored": "Cantonese"},
                  {"displayed": "Chinese - Simplified Subtitles", "stored": "Chinese - Simplified Subtitles"},
                  {"displayed": "Chinese - Traditional (Subtitles)", "stored": "Chinese - Traditional (Subtitles)"},
                  {"displayed": "Croatian", "stored": "Croatian"},
                  {"displayed": "Czech", "stored": "Czech"},
                  {"displayed": "Danish", "stored": "Danish"},
                  {"displayed": "Descriptive Video Service", "stored": "Descriptive Video Service"},
                  {"displayed": "Dialog Only", "stored": "Dialog Only"},
                  {"displayed": "Dutch", "stored": "Dutch"},
                  {"displayed": "English", "stored": "English"},
                  {"displayed": "English for Australia", "stored": "English for Australia"},
                  {"displayed": "English for South Africa", "stored": "English for South Africa"},
                  {"displayed": "English for UK", "stored": "English for UK"},
                  {"displayed": "Estonian", "stored": "Estonian"},
                  {"displayed": "Finnish", "stored": "Finnish"},
                  {"displayed": "Flemish", "stored": "Flemish"},
                  {"displayed": "French Canadian", "stored": "French Canadian"},
                  {"displayed": "French Parisian", "stored": "French Parisian"},
                  {"displayed": "German", "stored": "German"},
                  {"displayed": "Greek", "stored": "Greek"},
                  {"displayed": "Hebrew", "stored": "Hebrew"},
                  {"displayed": "Hindi", "stored": "Hindi"},
                  {"displayed": "Hungarian", "stored": "Hungarian"},
                  {"displayed": "Icelandic", "stored": "Icelandic"},
                  {"displayed": "Indonesian Bahasa", "stored": "Indonesian Bahasa"},
                  {"displayed": "Italian", "stored": "Italian"},
                  {"displayed": "Japanese", "stored": "Japanese"},
                  {"displayed": "Kazakh", "stored": "Kazakh"},
                  {"displayed": "Korean", "stored": "Korean"},
                  {"displayed": "Latvian", "stored": "Latvian"},
                  {"displayed": "Lithuanian", "stored": "Lithuanian"},
                  {"displayed": "Malay Bahasa", "stored": "Malay Bahasa"},
                  {"displayed": "Mandarin China", "stored": "Mandarin China"},
                  {"displayed": "Mandarin Taiwan", "stored": "Mandarin Taiwan"},
                  {"displayed": "No Texted Language", "stored": "No Texted Language"},
                  {"displayed": "Norwegian", "stored": "Norwegian"},
                  {"displayed": "Polish", "stored": "Polish"},
                  {"displayed": "Portuguese Brazil", "stored": "Portuguese Brazil"},
                  {"displayed": "Portuguese Euro", "stored": "Portuguese Euro"},
                  {"displayed": "Romanian", "stored": "Romanian"},
                  {"displayed": "Royal Institute For The Blind", "stored": "Royal Institute For The Blind"},
                  {"displayed": "Russian", "stored": "Russian"},
                  {"displayed": "Serbian", "stored": "Serbian"},
                  {"displayed": "Slovak", "stored": "Slovak"},
                  {"displayed": "Slovenian", "stored": "Slovenian"},
                  {"displayed": "Sound Effects Only", "stored": "Sound Effects Only"},
                  {"displayed": "Spanish Argentinean", "stored": "Spanish Argentinean"},
                  {"displayed": "Spanish Castilian", "stored": "Spanish Castilian"},
                  {"displayed": "Spanish Catalan", "stored": "Spanish Catalan"},
                  {"displayed": "Spanish Latin American", "stored": "Spanish Latin American"},
                  {"displayed": "Spanish Mexico", "stored": "Spanish Mexico"},
                  {"displayed": "Spanish Puerto Rico", "stored": "Spanish Puerto Rico"},
                  {"displayed": "Swedish", "stored": "Swedish"},
                  {"displayed": "Tagalog", "stored": "Tagalog"},
                  {"displayed": "Tamil", "stored": "Tamil"},
                  {"displayed": "Telugu", "stored": "Telugu"},
                  {"displayed": "Thai", "stored": "Thai"},
                  {"displayed": "Turkish", "stored": "Turkish"},
                  {"displayed": "Ukrainian", "stored": "Ukrainian"},
                  {"displayed": "Vietnamese", "stored": "Vietnamese"},
                  {"displayed": "Zulu", "stored": "Zulu"}
                ]
              }
            }, {
              "id": "configuration",
              "label": "Configuration",
              "type": "autocomplete_select",
              "width": 4,
              "options": {
                "data": [
                  {"displayed": "1.0 Mono", "stored": "1.0 Mono"},
                  {"displayed": "1.0 Mono (R128)", "stored": "1.0 Mono (R128)"},
                  {"displayed": "1.0 Mono M&E", "stored": "1.0 Mono M&E"},
                  {"displayed": "1.0 Mono Music", "stored": "1.0 Mono Music"},
                  {"displayed": "1.0 Dialog", "stored": "1.0 Dialog"},
                  {"displayed": "1.0 EFX", "stored": "1.0 EFX"},
                  {"displayed": "2.0 Left", "stored": "2.0 Left"},
                  {"displayed": "2.0 Left (R128)", "stored": "2.0 Left (R128)"},
                  {"displayed": "2.0 Left PAL Legal", "stored": "2.0 Left PAL Legal"},
                  {"displayed": "2.0 Left Total", "stored": "2.0 Left Total"},
                  {"displayed": "2.0 Left Total (FICAM)", "stored": "2.0 Left Total (FICAM)"},
                  {"displayed": "2.0 M&E Left Total", "stored": "2.0 M&E Left Total"},
                  {"displayed": "2.0 Music Left", "stored": "2.0 Music Left"},
                  {"displayed": "2.0 Right", "stored": "2.0 Right"},
                  {"displayed": "2.0 Right (R128)", "stored": "2.0 Right (R128)"},
                  {"displayed": "2.0 Right PAL Legal", "stored": "2.0 Right PAL Legal"},
                  {"displayed": "2.0 Right Total", "stored": "2.0 Right Total"},
                  {"displayed": "2.0 Right Total (FICAM)", "stored": "2.0 Right Total (FICAM)"},
                  {"displayed": "2.0 M&E Right Total", "stored": "2.0 M&E Right Total"},
                  {"displayed": "2.0 Music Right", "stored": "2.0 Music Right"},
                  {"displayed": "5.1 Center", "stored": "5.1 Center"},
                  {"displayed": "5.1 Center (FICAM)", "stored": "5.1 Center (FICAM)"},
                  {"displayed": "5.1 Center (R128)", "stored": "5.1 Center (R128)"},
                  {"displayed": "5.1 Left", "stored": "5.1 Left"},
                  {"displayed": "5.1 Left (FICAM)", "stored": "5.1 Left (FICAM)"},
                  {"displayed": "5.1 Left (R128)", "stored": "5.1 Left (R128)"},
                  {"displayed": "5.1 Left Surround", "stored": "5.1 Left Surround"},
                  {"displayed": "5.1 Left Surround (FICAM)", "stored": "5.1 Left Surround (FICAM)"},
                  {"displayed": "5.1 Left Surround (R128)", "stored": "5.1 Left Surround (R128)"},
                  {"displayed": "5.1 LFE (FICAM)", "stored": "5.1 LFE (FICAM)"},
                  {"displayed": "5.1 LFE (R128)", "stored": "5.1 LFE (R128)"},
                  {"displayed": "5.1 M&E Center", "stored": "5.1 M&E Center"},
                  {"displayed": "5.1 M&E Left", "stored": "5.1 M&E Left"},
                  {"displayed": "5.1 M&E Left Surround", "stored": "5.1 M&E Left Surround"},
                  {"displayed": "5.1 M&E Left Total", "stored": "5.1 M&E Left Total"},
                  {"displayed": "5.1 M&E LFE", "stored": "5.1 M&E LFE"},
                  {"displayed": "5.1 M&E Right", "stored": "5.1 M&E Right"},
                  {"displayed": "5.1 M&E Right Surround", "stored": "5.1 M&E Right Surround"},
                  {"displayed": "5.1 M&E Right Total", "stored": "5.1 M&E Right Total"},
                  {"displayed": "5.1 M&E Subwoofer", "stored": "5.1 M&E Subwoofer"},
                  {"displayed": "5.1 Right", "stored": "5.1 Right"},
                  {"displayed": "5.1 Right (FICAM)", "stored": "5.1 Right (FICAM)"},
                  {"displayed": "5.1 Right (R128)", "stored": "5.1 Right (R128)"},
                  {"displayed": "5.1 Right Surround", "stored": "5.1 Right Surround"},
                  {"displayed": "5.1 Right Surround (FICAM)", "stored": "5.1 Right Surround (FICAM)"},
                  {"displayed": "5.1 Right Surround (R128)", "stored": "5.1 Right Surround (R128)"},
                  {"displayed": "5.1 Subwoofer", "stored": "5.1 Subwoofer"},
                  {"displayed": "7.1 Center", "stored": "7.1 Center"},
                  {"displayed": "7.1 Dolby Digital", "stored": "7.1 Dolby Digital"},
                  {"displayed": "7.1 Dolby Digital+", "stored": "7.1 Dolby Digital+"},
                  {"displayed": "7.1 DTS", "stored": "7.1 DTS"},
                  {"displayed": "7.1 Left", "stored": "7.1 Left"},
                  {"displayed": "7.1 Left Surround", "stored": "7.1 Left Surround"},
                  {"displayed": "7.1 Left Surround Rear", "stored": "7.1 Left Surround Rear"},
                  {"displayed": "7.1 M&E Center", "stored": "7.1 M&E Center"},
                  {"displayed": "7.1 M&E Left", "stored": "7.1 M&E Left"},
                  {"displayed": "7.1 M&E Left Surround", "stored": "7.1 M&E Left Surround"},
                  {"displayed": "7.1 M&E Left Surround Rear", "stored": "7.1 M&E Left Surround Rear"},
                  {"displayed": "7.1 M&E Right", "stored": "7.1 M&E Right"},
                  {"displayed": "7.1 M&E Right Surround", "stored": "7.1 M&E Right Surround"},
                  {"displayed": "7.1 M&E Right Surround Rear", "stored": "7.1 M&E Right Surround Rear"},
                  {"displayed": "7.1 M&E Subwoofer", "stored": "7.1 M&E Subwoofer"},
                  {"displayed": "7.1 Right", "stored": "7.1 Right"},
                  {"displayed": "7.1 Right Surround", "stored": "7.1 Right Surround"},
                  {"displayed": "7.1 Right Surround Rear", "stored": "7.1 Right Surround Rear"},
                  {"displayed": "7.1 Subwoofer", "stored": "7.1 Subwoofer"},
                  {"displayed": "7.1+4 ATMOS", "stored": "7.1+4 ATMOS"},
                  {"displayed": "Audio Descriptive 2.0 LT", "stored": "Audio Descriptive 2.0 LT"},
                  {"displayed": "Audio Descriptive 2.0 RT", "stored": "Audio Descriptive 2.0 RT"},
                  {"displayed": "Dolby E 5.1/ 2.0", "stored": "Dolby E 5.1/ 2.0"},
                  {"displayed": "Dolby E 5.1/ 2.0 (R128)", "stored": "Dolby E 5.1/ 2.0 (R128)"},
                  {"displayed": "Effects", "stored": "Effects"},
                  {"displayed": "LAFFS", "stored": "LAFFS"},
                  {"displayed": "LO/RO", "stored": "LO/RO"},
                  {"displayed": "MOS", "stored": "MOS"},
                  {"displayed": "Music", "stored": "Music"},
                  {"displayed": "Narration", "stored": "Narration"},
                  {"displayed": "Optional", "stored": "Optional"},
                  {"displayed": "Production", "stored": "Production"},
                  {"displayed": "Stereo Comp", "stored": "Stereo Comp"},
                  {"displayed": "Stereo Comp L", "stored": "Stereo Comp L"},
                  {"displayed": "Stereo Comp R", "stored": "Stereo Comp R"},
                  {"displayed": "Stereo M&E", "stored": "Stereo M&E"},
                  {"displayed": "Stereo M&E L", "stored": "Stereo M&E L"},
                  {"displayed": "Stereo M&E R", "stored": "Stereo M&E R"},
                  {"displayed": "Voice Over", "stored": "Voice Over"}
                ]
              }
            },
            {
              "id": "tone",
              "label": "Tone",
              "type": "text",
              "width": 1,
              "options": {}
            },
            {
              "id": "peak",
              "label": "Peak",
              "type": "text",
              "width": 1,
              "options": {}
            }, {
              "id": "average",
              "label": "Avg",
              "type": "text",
              "width": 1,
              "options": {}
            }, {
              "id": "unit",
              "label": "Unit",
              "type": "autocomplete_select",
              "width": 1,
              "options": {
                "data": [
                  {"displayed": "dB", "stored": "dB"},
                  {"displayed": "dBFS ", "stored": "dBFS"},
                  {"displayed": "LKFS", "stored": "LKFS"}
                ],
                "default": {"displayed": "dBFS", "stored": "dBFS"}
              }
            },
            {
              "id": "qc_result",
              "label": "QC Result",
              "type": "autocomplete_select",
              "width": 2,
              "options": {
                "data": [
                  {"displayed": "Fail", "stored": "Fail"},
                  {"displayed": "Pass", "stored": "Pass"},
                  {"displayed": "Spot Check", "stored": "Spot Check"}
                ]
              }
            }
          ]
        }
      ]]
    },
    {
      "section_name": "Technical Specifications",
      "width": 9,
      "rows": [[
        {
          "id": "tech_specs_format",
          "type": "select",
          "label": "Format",
          "width": 1,
          "links": [
            {"id": "luminance_avg"},
            {"id": "luminance_max"},
            {"id": "luminance_bars"},
            {"id": "chrominance_avg"},
            {"id": "chrominance_max"},
            {"id": "chrominance_bars"},
            {"id": "setup"}
          ],
          "options": {
            "data": [
              {"displayed": "HD", "stored": "hd", "linked_categories": ["hd"]},
              {"displayed": "SD", "stored": "sd", "linked_categories": ["sd"]}
            ],
            "blankOptionVisible": false,
            "default": {"displayed": "HD", "stored": "hd"}
          }
        }
      ],
      [
        {
          "id": "luminance_avg",
          "type": "tech_specs",
          "label": "Luminance Avg",
          "hints": {
            "hd": "400-500 mV",
            "sd": "0-50 IRE"
          },
          "width": 3,
          "options": {
            "suffixes": {
              "hd": "mV",
              "sd": "IRE"
            }
          }
        },
        {
          "id": "luminance_max",
          "type": "tech_specs",
          "label": "Luminance Max",
          "hints": {
            "hd": "700 mV",
            "sd": "0-120 IRE"
          },
          "width": 3,
          "options": {
            "suffixes": {
              "hd": "mV",
              "sd": "IRE"
            }
          }
        },
        {
          "id": "chrominance_avg",
          "type": "tech_specs",
          "label": "Chrominance Avg",
          "hints": {
            "hd": "200-300 mV",
            "sd": "0-30 IRE"
          },
          "width": 3,
          "options": {
            "suffixes": {
              "hd": "mV",
              "sd": "IRE"
            }
          }
        },
        {
          "id": "chrominance_max",
          "type": "tech_specs",
          "label": "Chrominance Max",
          "hints": {
            "hd": "700 mV",
            "sd": "0-60 IRE"
          },
          "width": 3,
          "options": {
            "suffixes": {
              "hd": "mV",
              "sd": "IRE"
            }
          }
        }
      ],
      [
        {
          "id": "luminance_bars",
          "type": "tech_specs",
          "label": "Luminance Bars",
          "hints": {
            "hd": "75% Color Bars = 700mV\n100% Color Bars = 700mV",
            "sd": "100 IRE"
          },
          "width": 3,
          "options": {
            "suffixes": {
              "hd": "mV",
              "sd": "IRE"
            }
          }
        },
        {
          "id": "chrominance_bars",
          "type": "tech_specs",
          "label": "Chrominance Bars",
          "hints": {
            "hd": "75% Color Bars = 525mV\n100% Color Bars = 700mV",
            "sd": "100 IRE"
          },
          "width": 3,
          "options": {
            "suffixes": {
              "hd": "mV",
              "sd": "IRE"
            }
          }
        },
        {
          "id": "horizontal_blanking",
          "type": "text",
          "label": "Horizontal Blanking",
          "hint": "10.2 - 10.8μs\n10.6 - 11.7μs",
          "width": 3,
          "options": {
            "suffix": "μs"
          }
        },
        {
          "id": "vertical_blanking",
          "type": "text",
          "label": "Vertical Blanking",
          "hint": "19 - 21μs\n22 - 25μs",
          "width": 3,
          "options": {
            "suffix": "μs"
          }
        }
      ],
      [
        {
          "id": "setup",
          "type": "tech_specs",
          "label": "Set-up",
          "hints": {
            "hd": "0 mV",
            "sd": "07.5 IRE"
          },
          "width": 3,
          "options": {
            "suffixes": {
              "hd": "mV",
              "sd": "IRE"
            }
          }
        },
        {
          "id": "vitc",
          "type": "text",
          "label": "VITC",
          "hint": "12 & 14\n19 & 21",
          "width": 3,
          "options": {
            "data": [
              {"displayed": "Yes", "stored": "Yes"},
              {"displayed": "No", "stored": "No"}
            ]
          }
        },
        {
          "id": "r128_compliance",
          "type": "autocomplete_select",
          "label": "R128 Compliance",
          "width": 3,
          "options": {
            "data": [
              {"displayed": "Not Checked", "stored": "Not Checked"},
              {"displayed": "Yes", "stored": "Yes"},
              {"displayed": "No", "stored": "No"}
            ]
          }
        },
        {
          "id": "calm_compliance",
          "type": "autocomplete_select",
          "label": "CALM Compliance",
          "width": 3,
          "options": {
            "data": [
              {"displayed": "Not Checked", "stored": "Not Checked"},
              {"displayed": "Yes", "stored": "Yes"},
              {"displayed": "No", "stored": "No"}
            ]
          }
        }
      ],
      [
        {
          "id": "closed_caption_line",
          "type": "text",
          "label": "Closed Caption Line",
          "hint": "21\n23",
          "width": 3,
          "options": { }
        },
        {
          "id": "closed_caption_amplitude",
          "type": "text",
          "label": "C.C. Amplitude",
          "hint": "310-380mV",
          "width": 3,
          "options": {
            "suffix": "mV"
          }
        },
        {
          "id": "closed_caption_timing",
          "type": "text",
          "label": "C.C. Timing",
          "hint": "1.25-1.75μs",
          "width": 3,
          "options": {
            "suffix": "μs"
          }
        }
      ]]
    },
    {
      "section_name": "Segments",
      "width": 8,
      "rows": [[
        {
          "id": "segments",
          "label": "",
          "type": "table",
          "width": 8,
          "options": {
            "min_value": 1,
            "sort_by": ["timecode_in"]
          },
          "fields": [
            {
              "id": "timecode_in",
              "label": "Timecode In",
              "type": "timecode",
              "options": { }
            }, {
              "id": "timecode_out",
              "label": "Timecode Out",
              "type": "timecode",
              "options": { }
            }, {
              "id": "description",
              "label": "Description",
              "type": "text",
              "width": 4,
              "options": {}
            }, {
              "id": "duration",
              "label": "Duration",
              "type": "timecode",
              "options": { }
            }, {
              "id": "segment_category",
              "label": "Category",
              "type": "autocomplete_select",
              "width": 2,
              "options": {
                "data": [
                  {"displayed": "ABC Spark", "stored": "ABC Spark"},
                  {"displayed": "Dub Credits", "stored": "Dub Credits"},
                  {"displayed": "Alt Ending", "stored": "Alt Ending"},
                  {"displayed": "Alt End Credits", "stored": "Alt End Credits"},
                  {"displayed": "International Content End Credits", "stored": "International Content End Credits"},
                  {"displayed": "Domestic Textless Bed", "stored": "Domestic Textless Bed"},
                  {"displayed": "Alt Main Title", "stored": "Alt Main Title"},
                  {"displayed": "Alt 4x3 Material", "stored": "Alt 4x3 Material"},
                  {"displayed": "Other", "stored": "Other"}
                ]
              }
            }, {
            "id": "anomaly",
            "label": "Anomaly",
            "type": "anomalies",
            "width": 0,
            "locked": true,
            "links": [{"id": "program_notes", "row": true, "match": ["Segment"]}],
            "options": {
              "default": {"displayed": "Segment", "stored": "Segment"}
            }
          }]
        }
      ]]
    },
    {
      "section_name": "General Comments",
      "width": 9,
      "rows": [
      [
        {
          "id": "general_comments",
          "type": "textarea",
          "label": "Comments",
          "width": 9,
          "options": {}
        }
      ]]
    },
    {
      "section_name": "High Priority Notes",
      "rows": [[{
        "id": "high_priority_notes",
        "label": "",
        "type": "table",
        "width": 12,
        "options": {
          "sort_by": ["timecode_in", "textless_number"]
        },
        "fields": [
          {
            "id": "timecode_in",
            "label": "Timecode In",
            "type": "timecode",
            "options": {
            }
          }, {
            "id": "timecode_out",
            "label": "Timecode Out",
            "type": "timecode",
            "options": { }
          }, {
            "id": "avf",
            "label": "AVF",
            "type": "autocomplete_select",
            "width": 0.5,
            "align": "center",
            "links": [{"id": "anomaly"}],
            "options": {
              "data": [
                {"displayed": "A", "stored": "A", "linked_categories": ["A"]},
                {"displayed": "V", "stored": "V", "linked_categories": ["V"]},
                {"displayed": "AV", "stored": "AV", "linked_categories": ["A", "V"]},
                {"displayed": "F", "stored": "F", "linked_categories": ["F"]},
                {"displayed": "Other", "stored": "Other", "linked_categories": null}
              ]
            }
          }, {
            "id": "anomaly",
            "label": "Anomaly/Event",
            "type": "anomalies",
            "width": 2,
            "options": {
              "highlight_values": ["Black"],
              "highlight_color": "yellow",
              "dropdownWidth": 240
            }
          }, {
            "id": "description",
            "label": "Description",
            "type": "textarea",
            "width": 6,
            "options": { }
          }, {
            "id": "textless_number",
            "label": "TX#",
            "type": "index",
            "align": "center",
            "options": {
              "highlight_pattern": "\\d+",
              "highlight_color": "yellow"
            }
          }, {
            "id": "duration",
            "label": "Duration",
            "type": "timecode",
            "options": { }
          }, {
            "id": "scale",
            "label": "Scale",
            "type": "autocomplete_select",
            "width": 0.5,
            "align": "center",
            "locked": true,
            "links": [{"id": "program_notes", "row": true, "match": ["3"]}],
            "options": {
              "default": {"displayed": "3", "stored": "3"},
              "highlight_values": ["3"],
              "highlight_color": "red",
              "data": [
                {"displayed": "FYI", "stored": "FYI"},
                {"displayed": "1", "stored": "1"},
                {"displayed": "2", "stored": "2"},
                {"displayed": "3", "stored": "3"}
              ]
            }
          }, {
            "id": "channel_sector",
            "label": "Chan/Sector",
            "type": "text",
            "width": 0.5,
            "align": "center",
            "options": {}
          }, {
            "id": "production_notes",
            "label": "Production Notes",
            "type": "autocomplete_select",
            "width": 2,
            "options": {
              "data": [
                {"displayed": "Creative Intent", "stored": "Creative Intent"},
                {"displayed": "Fixed", "stored": "Fixed"},
                {"displayed": "Mastering Approved As Is", "stored": "Mastering Approved As Is"},
                {"displayed": "Not Fixed", "stored": "Not Fixed"},
                {"displayed": "Partial Fix", "stored": "Partial Fix"},
                {"displayed": "Production Approved As Is", "stored": "Production Approved As Is"},
                {"displayed": "Updated", "stored": "Updated"}
              ]
            }
          }
        ]
      }]]
    },
    {
      "section_name": "Program Notes",
      "rows": [[
        {
          "id": "notes_standard",
          "type": "timecode_standard",
          "width": 4,
          "options": { }
        },
        {
          "id": "convert",
          "type": "convert",
          "options": { }
        },
        {
          "id": "offset",
          "type": "offset",
          "options": { }
        }
      ], [
        {
          "id": "program_notes",
          "label": "",
          "type": "table",
          "width": 12,
          "options": {
            "min_value": 1,
            "csv": true,
            "sort_by": ["timecode_in", "textless_number"]
          },
          "fields": [
            {
              "id": "timecode_in",
              "label": "Timecode In",
              "type": "timecode",
              "options": {
              }
            }, {
              "id": "timecode_out",
              "label": "Timecode Out",
              "type": "timecode",
              "options": { }
            }, {
              "id": "avf",
              "label": "AVF",
              "type": "autocomplete_select",
              "width": 0.5,
              "align": "center",
              "links": [{"id": "anomaly"}],
              "options": {
                "data": [
                  {"displayed": "A", "stored": "A", "linked_categories": ["A"]},
                  {"displayed": "V", "stored": "V", "linked_categories": ["V"]},
                  {"displayed": "AV", "stored": "AV", "linked_categories": ["A", "V"]},
                  {"displayed": "F", "stored": "F", "linked_categories": ["F"]},
                  {"displayed": "Other", "stored": "Other", "linked_categories": null}
                ]
              }
            }, {
              "id": "anomaly",
              "label": "Anomaly/Event",
              "type": "anomalies",
              "width": 2,
              "links": [
                {"id": "segments", "row": true, "match": ["Segment"]},
                {"id": "nonsubtitled_material", "row": true, "match": ["Non-Subtitled"]}
              ],
              "options": {
                "highlight_values": ["Black"],
                "highlight_color": "yellow",
                "dropdownWidth": 240
              }
            }, {
              "id": "description",
              "label": "Description",
              "type": "textarea",
              "width": 6,
              "options": { }
            }, {
              "id": "textless_number",
              "label": "TX#",
              "type": "index",
              "align": "center",
              "links": [{"id": "textless", "row": true, "addOnly": true, "presence": true, "fields": ["description", "textless_number"]}],
              "options": {
                "highlight_pattern": "\\d+",
                "highlight_color": "yellow"
              }
            }, {
              "id": "duration",
              "label": "Duration",
              "type": "timecode",
              "options": { }
            }, {
              "id": "scale",
              "label": "Scale",
              "type": "autocomplete_select",
              "width": 0.5,
              "align": "center",
              "links": [{"id": "high_priority_notes", "row": true, "match": ["3"]}],
              "options": {
                "highlight_values": ["3"],
                "highlight_color": "red",
                "data": [
                  {"displayed": "FYI", "stored": "FYI"},
                  {"displayed": "1", "stored": "1"},
                  {"displayed": "2", "stored": "2"},
                  {"displayed": "3", "stored": "3"}
                ]
              }
            }, {
              "id": "channel_sector",
              "label": "Chan/Sector",
              "type": "text",
              "width": 0.5,
              "align": "center",
              "options": {}
            }, {
              "id": "production_notes",
              "label": "Production Notes",
              "type": "autocomplete_select",
              "width": 2,
              "options": {
                "data": [
                  {"displayed": "Creative Intent", "stored": "Creative Intent"},
                  {"displayed": "Fixed", "stored": "Fixed"},
                  {"displayed": "Mastering Approved As Is", "stored": "Mastering Approved As Is"},
                  {"displayed": "Not Fixed", "stored": "Not Fixed"},
                  {"displayed": "Partial Fix", "stored": "Partial Fix"},
                  {"displayed": "Production Approved As Is", "stored": "Production Approved As Is"},
                  {"displayed": "Updated", "stored": "Updated"}
                ]
              }
            }/* , {
              "id": "in_source",
              "label": "In Source",
              "type": "autocomplete_select",
              "width": 1,
              "options": {
                "data": [
                  {"displayed": "Yes", "stored": "Yes"},
                  {"displayed": "No", "stored": "No"}
                ]
              }
            }, {
              "id": "sign_off",
              "label": "Sign-Off",
              "type": "text",
              "width": 1,
              "options": {}
            } */
          ]
        }
      ]]
    },
    {
      "section_name": "Textless",
      "width": 9,
      "rows": [[{
        "id": "textless",
        "label": "",
        "type": "table",
        "width": 9,
        "options": {
          "min_value": 1,
          "csv": true,
          "sort_by": ["timecode_in", "textless_number"]
        },
        "fields": [
          {
            "id": "timecode_in",
            "label": "Timecode In",
            "type": "timecode",
            "options": {
            }
          }, {
            "id": "timecode_out",
            "label": "Timecode Out",
            "type": "timecode",
            "options": {
            }
          }, {
            "id": "description",
            "label": "Description",
            "type": "textarea",
            "width": 5,
            "options": { }
          }, {
            "id": "textless_number",
            "label": "TX#",
            "type": "index",
            "align": "center",
            "links": [{"id": "program_notes", "row": true, "addOnly": true, "presence": true, "fields": ["description", "textless_number"]}],
            "options": {}
          }, {
            "id": "status",
            "label": "Status",
            "type": "autocomplete_select",
            "width": 2,
            "options": {
              "data": [
                {"displayed": "Complete", "stored": "Complete"},
                {"displayed": "Partial", "stored": "Partial"}
              ]
            }
          }, {
            "id": "duration",
            "label": "Duration",
            "type": "timecode",
            "options": { }
          }
        ]
      }]]
    },
    {
      "section_name": "Dialog Non-Subtitled Material",
      "width": 9,
      "rows": [[{
        "id": "nonsubtitled_material",
        "label": "",
        "type": "table",
        "width": 9,
        "options": {
          "min_value": 1,
          "sort_by": ["timecode_in", "dns_number"]
        },
        "fields": [
          {
            "id": "timecode_in",
            "label": "Timecode In",
            "type": "timecode",
            "options": {
            }
          }, {
            "id": "timecode_out",
            "label": "Timecode Out",
            "type": "timecode",
            "options": {
            }
          }, {
            "id": "description",
            "label": "Description",
            "type": "textarea",
            "width": 5,
            "options": { }
          }, {
            "id": "dns_number",
            "label": "DNS#",
            "type": "auto_index",
            "align": "center",
            "options": { }
          }, {
            "id": "duration",
            "label": "Duration",
            "type": "timecode",
            "options": { }
          }, {
            "id": "anomaly",
            "label": "Anomaly",
            "type": "anomalies",
            "width": 0,
            "locked": true,
            "links": [{"id": "program_notes", "row": true, "match":["Non-Subtitled"]}],
            "options": {
              "default": {"displayed": "Non-Subtitled", "stored": "Non-Subtitled"}
            }
          }
        ]
      }]]
    }
  ]}
}



// WEBPACK FOOTER //
// ./src/app/workflows/qc-tv-workflow.ts